import ability from '@/libs/acl/ability'
import { entityFaq, entityImportExport, entitySubscriptionInvoice, entitySmsBalanceInvoice } from '@/libs/acl/entities'
import appConstants from '@/constants/constants'
import { getDataFromLocalStorageByPrefix } from '@/composables/localStorageHelper'
import useApp from '@/composables/app'

export const canNavigate = to => to.matched.some(route => {
  if ([entityFaq, entitySubscriptionInvoice, entitySmsBalanceInvoice].includes(route.meta.resource)) {
    return true
  }
  const user = JSON.parse(localStorage.getItem('user'))
  if (
    route.meta.resource === entityImportExport && user
    && [appConstants.role.type.SYS_ADMIN, appConstants.role.type.SUPPORT].includes(user.role_type)
  ) {
    return true
  }
  if (route.meta.resource === 'pricingtypevalue') {
    return user && ['sys_admin', 'root', 'support'].includes(user.role_type)
  }
  if (route.meta.resource === 'integratorbranch') {
    return user && ['root'].includes(user.role_type)
  }
  return Array.isArray(route.meta.resource)
    ? route.meta.resource.some(r => ability.can(route.meta.action || 'read', r))
    : ability.can(route.meta.action || 'read', route.meta.resource)
})

export const needReAuth = () => {
  let lActTm = getDataFromLocalStorageByPrefix(appConstants.user.sessionState.LAST_ACTION_LOCAL_STORAGE_KEY)
  if (!lActTm) {
    return true
  }

  const { getCurrentTime } = useApp()
  const ctm = getCurrentTime()
  const maxDiff = 3540000
  return ctm - lActTm > maxDiff
}

export const _ = undefined
